<template>
  <div>
    <h1 class="text-center my-5">PRIVATE EQUITY ANALYST, <span class="text-black-50">INDIA</span></h1>
    <p class="mb-5">
      Actively participate in the early stages of a <b>high-growth data & software start-up
      focused on Private Capital</b>. A unique learning experience in Private Equity (PE),
      Operations and Data.
    </p>
    <h4 class="mb-3">The opportunity</h4>
    <p>
      <span class="logo-text">mktBI</span>
      develops <b>data analytics & visualization software for Private Capital
      investment professionals</b>. Through a combination of data science and business
      analysis, our interfaces render cherry-picked information for mission-critical activities.
      You can view a video demo of our latest product
      <a href="https://vimeo.com/498053230/fe9bb2806a" target="_blank">here.</a>
    </p>
    <p>
      The company was founded in 2019 by a former partner in a large cap PE firm, with funds
      totalling $30bn. He participated in transactions with a collective enterprise value of $7bn.
      Together with another two PE partners advising our company, they have 45 years of
      sector experience. Today, our management is formed of <b>PE, consulting and software
      senior executives</b> combining 50+ years of experience.
    </p>
    <p>
      We have <b>raised a large Seed Round and agreed the first deployments</b> at
      renowned PE firms. Our investors include partners from leading firms, such as KKR, Vista,
      Bridgepoint, BC Partners and Eurazeo.
    </p>
    <h4 class="mb-3">Your role</h4>
    <p>
      With <b>data completeness and accuracy</b> being cornerstones of our value proposition,
      our PE analysts are essential to the success of the company. Whilst the data originates
      from providers, your team will <b>review</b> it, and add <b>vital information</b> through:
    </p>
    <ul>
      <li>Building and maintaining lists of <b>PE targets, deals and precedent transactions</b>;</li>
      <li><b>Consolidating data</b> across our database and external providers;</li>
      <li>Monitoring <b>company news</b> flows;</li>
      <li>
        Leveraging in-depth <b>knowledge of specific economic sectors</b> (valuations,
        recent events, key players, ...);
      </li>
      <li>Maintaining <b>profiles of key investors</b>; PEs, LPs, VCs, and family offices.</li>
    </ul>
    <p>
      As we expand, strong performers will have the opportunity to evolve into management,
      or product roles.
    </p>
    <h4 class="mb-3">Our commitment to you</h4>
    <ul>
      <li><b>Competitive base salary</b> and discretionary <b>performance bonus</b>;</li>
      <li>
        Adequate <b>investments</b> for the success of the offshore business (office space,
        laptops, ...);
      </li>
      <li>
        Facilitate your work through a structured <b>operational framework</b>, and flexible
        work arrangements;
      </li>
      <li>
        Learn about <b>private capital, operations, tech</b>, and <b>data science</b> from industry
        senior executives;
      </li>
      <li>For strong performers, a <b>secondment to our London team</b>;</li>
      <li>And an opportunity to move onto <b>revenue-generating services</b>.</li>
    </ul>
    <h4 class="mb-3">Your profile</h4>
    <p>
      You hold a <b>bachelor</b> or <b>master’s degree</b> in finance, business, or related fields. You
      have a keen interest in <b>Finance</b>, and in working with <b>data</b>. Previous experience in the
      Finance or data sectors is a plus.
    </p>
    <p>
      You must be comfortable with:
    </p>
    <ul>
      <li>
        <b>Analysing financial statements</b> and annual reports (a CFA certification or equivalent is a plus);
      </li>
      <li>Fundamental <b>M&A concepts</b> such as investment strategies, and valuation methods;</li>
      <li>Collecting and critically <b>assessing vast amounts of information</b>, in a time-boxed environment;</li>
      <li>Organising data in Microsoft <b>Excel</b>;</li>
      <li>Experience in searching and analysing <b>business and financial databases</b> is a plus.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "private-equity-analyst"
}
</script>

<style scoped lang="scss">

h1 {
  font-size: 50px;
  padding: 50px 0 32px;
  font-weight: 700;

  img {
    height: 50px;
    margin-left: 15px;
  }

  @media(max-width: 640px) {
    font-size: 36px;
    img {
      height: 36px;
    }
  }
}

h4 {
  font-size: 36px;
}

li {
  color: #767f86;
  font-weight: 400;
}

p {
  color: #767f86;
  font-style: normal;
  font-weight: 400;
  @media(max-width: 640px) {
    font-size: 18px;
  }
}
</style>